import React from 'react'
import { useSelector } from 'react-redux'
import PaymentsAppsumo from './PaymentsAppsumo'
import PaymentsNocode from './PaymentsNocode'
import appsumoSelectors from 'store/selectors/appsumo'

const AccountPayments = ({

}) => {
  
  const isAppsumo = useSelector(appsumoSelectors.isAppsumo)

  return isAppsumo ? (
    <PaymentsAppsumo />
  ) : (
    <PaymentsNocode />
  )
  
}

export default AccountPayments